function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import React, { useCallback, useContext, useEffect, useRef } from "react";
import Col from "../../Col";
import Row from "../../Row";
import Icon, { ICON_PLACEMENT } from "./AccordionIcon";
import { useStyle } from "./AccordionSection.styles";
import { CarinaContext } from "../../CarinaProvider";
import { useTheme } from "../../ThemeProvider/useTheme";
import { resolveIds } from "../../../utils";
import { Collapse } from "../../Collapse";
import { applySpreaderProp } from "../../../utils/applySpreaderProp";
import { transitionDurationToNum } from "../../../utils/styleUtils";
var AccordionHeader = function(_param) {
    var isOpen = _param.isOpen, label = _param.label, description = _param.description, chevronPlacement = _param.chevronPlacement, testID = _param.testID, isRtl = _param.isRtl, paddingMode = _param.paddingMode, props = _objectWithoutProperties(_param, [
        "isOpen",
        "label",
        "description",
        "chevronPlacement",
        "testID",
        "isRtl",
        "paddingMode"
    ]);
    var ref = useStyle({
        isRtl: isRtl,
        isOpen: isOpen,
        paddingMode: paddingMode
    }), header = ref.header, labelText = ref.labelText, descriptionText = ref.descriptionText;
    return _jsx("div", {
        css: header,
        children: _jsxs(Row, {
            margin: 0,
            isRtl: isRtl,
            children: [
                chevronPlacement === 'start' && _jsx(Icon, _objectSpread({}, props, {
                    isOpen: isOpen,
                    chevronPlacement: chevronPlacement,
                    isLeft: true,
                    isRtl: isRtl,
                    testID: testID
                })),
                _jsxs(Col, {
                    width: "fill",
                    padding: 0,
                    isRtl: isRtl,
                    children: [
                        _jsx("div", _objectSpread({}, resolveIds(undefined, testID, 'section-label'), {
                            css: labelText,
                            children: label
                        })),
                        _jsx("div", _objectSpread({}, resolveIds(undefined, testID, 'section-description'), {
                            css: descriptionText,
                            children: description
                        }))
                    ]
                }),
                chevronPlacement === 'end' && _jsx(Icon, _objectSpread({}, props, {
                    isOpen: isOpen,
                    chevronPlacement: chevronPlacement,
                    isRtl: isRtl,
                    isLeft: false,
                    testID: testID
                }))
            ]
        })
    });
};
var AccordionSection = function(_param) {
    var chevronPlacement = _param.chevronPlacement, children = _param.children, content = _param.content, description = _param.description, focused = _param.focused, handleArrowKeyPress = _param.handleArrowKeyPress, index = _param.index, isCollapsible = _param.isCollapsible, isOpen = _param.isOpen, isRtl = _param.isRtl, label = _param.label, onClick = _param.onClick, paddingMode = _param.paddingMode, testID = _param.testID, transitionProps = _param.transitionProps, props = _objectWithoutProperties(_param, [
        "chevronPlacement",
        "children",
        "content",
        "description",
        "focused",
        "handleArrowKeyPress",
        "index",
        "isCollapsible",
        "isOpen",
        "isRtl",
        "label",
        "onClick",
        "paddingMode",
        "testID",
        "transitionProps"
    ]);
    var ref = useStyle({
        isRtl: isRtl,
        paddingMode: paddingMode
    }), section = ref.section, container = ref.container, panel = ref.panel, panelText = ref.panelText;
    var headerRef = useRef(null);
    useEffect(function() {
        if (focused && headerRef.current) {
            headerRef.current.focus();
        }
    }, [
        focused
    ]);
    var onSectionClick = useCallback(function() {
        if (isCollapsible) {
            onClick(index);
        }
    }, [
        isCollapsible,
        onClick,
        index
    ]);
    var handleKeyDown = function(keyEvent) {
        switch(keyEvent.key){
            case 'Enter':
            case ' ':
                onSectionClick();
                break;
            case 'ArrowDown':
                handleArrowKeyPress(1, keyEvent);
                break;
            case 'ArrowUp':
                handleArrowKeyPress(-1, keyEvent);
                break;
            default:
                break;
        }
    };
    var theme = useTheme();
    var ref1;
    var prefersReducedMotion = ((ref1 = useContext(CarinaContext)) !== null && ref1 !== void 0 ? ref1 : {
        prefersReducedMotion: false
    }).prefersReducedMotion;
    var durationToken = prefersReducedMotion ? theme.animation.duration.reducedMotion : theme.animation.duration[100];
    var duration = transitionDurationToNum(durationToken);
    var transitions = prefersReducedMotion ? [
        'fade',
        {
            exited: {
                maxHeight: 0,
                overflow: 'hidden'
            },
            transitionProperty: ''
        }
    ] : 'fade';
    var calculatedTransitionProps = applySpreaderProp(transitionProps, {
        duration: duration,
        in: isOpen,
        isCollapseDisabled: prefersReducedMotion,
        transitions: transitions,
        easing: 'productive.easeInOut'
    });
    return _jsxs("div", {
        css: section,
        children: [
            _jsx("div", _objectSpread({}, resolveIds(undefined, testID, "section-".concat(index)), {
                role: "button",
                onClick: onSectionClick,
                onKeyDown: handleKeyDown,
                tabIndex: 0,
                ref: headerRef,
                "aria-expanded": isOpen,
                css: container,
                children: _jsx(AccordionHeader, _objectSpread({}, props, {
                    isOpen: isOpen,
                    label: label,
                    description: description,
                    chevronPlacement: chevronPlacement,
                    testID: testID,
                    isRtl: isRtl,
                    paddingMode: paddingMode
                }))
            })),
            _jsx(Collapse, _objectSpread({}, calculatedTransitionProps, {
                children: _jsx("div", _objectSpread({}, resolveIds(undefined, testID, "section-content-".concat(index)), {
                    id: "accordion-section-".concat(index),
                    css: panel,
                    children: _jsx(Row, {
                        children: _jsx(Col, {
                            width: "fill",
                            offset: chevronPlacement === ICON_PLACEMENT.START || props.icon ? 40 : 8,
                            padding: {
                                end: 16
                            },
                            isRtl: isRtl,
                            children: _jsx("div", _objectSpread({}, resolveIds(undefined, testID, 'section-content-panel'), {
                                css: panelText,
                                inert: isOpen ? null : '',
                                children: content || children
                            }))
                        })
                    })
                }))
            }))
        ]
    });
};
export { AccordionSection };
